import { lazy } from 'react';

const LazyTermsAndConditions = lazy(() => import('./terms-and-conditions'));
export default LazyTermsAndConditions;
